const TRANSACTIONS_TYPES = {
  CHARGE: 5,
  REFUND: 7,
  VALIDATION: 8,
  PARTIAL_VALIDATION: 12
}

const VALIDATIONS_TYPES = {
  FLAT_RATE: 1,
  HOP_ON_HOP_OFF: 2,
  PENALTY: 3
}

const MENU_OPTIONS_IGN = {
  MUNICIPALITY_RECHARGE: 'municipality-recharge',
  MUNICIPALITY_ADVERTISING: 'municipality-advertising',
  MUNICIPALITY_VAMUS_EXP: 'municipality-vamus-experiences',
  MUNICIPALITY_NETWORK_MAP: 'municipality-network-map',
  MUNICIPALITY_PLANNER: 'municipality-planner',
  MUNICIPALITY_MOVEMENTS: 'municipality-movements-history',
  RENTING: 'renting',
  MUNICIPALITY_SERV_CHANNEL: 'municipality-service-channel'
}

const APP_CODE = {
  RD: 'rd',
  VZ: 'vz',
  VL: 'vl',
  MR: 'mr',
  GC: 'gc'
}

export {
  TRANSACTIONS_TYPES,
  VALIDATIONS_TYPES,
  MENU_OPTIONS_IGN,
  APP_CODE
}

